export default __webpack_public_path__ + "static/media/add-icon.e9b19a60.svg";